<template>
  <div>
    <el-card class="box-card box-cards" shadow="never">
      <el-row>
        <el-form :inline="true" class="user-search">
          <el-col :span="24">
            <el-form-item>
              <div class="card_top"><span>词书列表</span></div>
            </el-form-item>
            <el-form-item label="搜索：">
              <el-input size="small" v-model="formInline.params.keyword" placeholder="输入关键字">
                <el-select v-model="formInline.params.category" slot="prepend" placeholder="分类">
                  <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
              <el-button size="small" type="primary" plain @click="handleEdit()">添加
              </el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </el-card>
    <el-card class="box-card box-cards2" shadow="never">
      <!--列表-->
      <el-table border ref="multipleTable" :data="tableData" :header-cell-style="headStyle" tooltip-effect="dark"
        style="width: 100%; " v-loading="loading">
        <el-table-column prop="id" label="词书id" align="center" width="140"></el-table-column>
        <el-table-column prop="image" label="封面图" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.coverUrl" alt="" srcset="" width="60" height="60" />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="词书名称" align="center"></el-table-column>
        <el-table-column prop="description" label="词书描述" align="center"></el-table-column>

        <el-table-column prop="is_show" label="状态" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.status == 0 ? '不显示' : '显示' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="wordCount" label="单词数量" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.wordCount }} <el-button type="primary" plain icon="el-icon-refresh-right" circle
                size="mini" title="刷新数量" @click="refreshCount(scope.row.id)"></el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" align="center"></el-table-column>
        <el-table-column prop="jtime" label="更新时间" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.updatedAt | timestampToTime }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="260">
          <template slot-scope="scope">
            <div>
              <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">修改 </el-button>
              <el-button size="mini" type="danger" @click="handleEditdel(scope.row.id)">删除 </el-button>
              <el-button size="mini" type="success" @click="jihua(scope.row)">兑换码列表 </el-button>
            </div>
            <div style="margin-top: 10px;">
              <el-button size="mini" @click="showunits(scope.row)">单元 </el-button>
              <el-button size="mini" @click="peizhi(scope.row)">单词 </el-button>
              <el-button @click="showQrcode(scope.row)" size="small">小程序码</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </el-card>
    <el-dialog title="查看小程序码" :visible.sync="dialogVisible" width="500px">
      <div v-loading="loading">
        <div style="width: 430px;height: 430px;margin:0 auto">
          <img v-if="dialogImageUrl" :src="dialogImageUrl" style="width: 100%;height: 100%;" />
        </div>
      </div>
    </el-dialog>
    <el-drawer :title="title" :visible.sync="editFormVisible" :before-close="handleClose" direction="rtl"
      custom-class="demo-drawer" ref="drawer" size="40%">
      <div class="demo-drawer__content">
        <el-row>
          <el-form label-width="110px" :model="editForm" :rules="rules" ref="editForm">
            <el-col :span="22">
              <div class="grid-content bg-purple">
                <el-form-item label="书词分类" prop="name">
                  <el-select v-model="editForm.params.category" placeholder="请选择书词分类">
                    <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="书词名称" prop="name">
                  <el-input v-model="editForm.params.name" placeholder="请输入书词名称"></el-input>
                </el-form-item>
                <el-form-item label="封面图：" prop="logo">
                  <el-upload class="avatar-uploader" name="files" :action="imagesrc" :headers="uploadHeader"
                    :show-file-list="false" :on-success="licenseSuccess" :before-upload="beforeAvatarUpload">
                    <img v-if="editForm.params.coverUrl" :src="editForm.params.coverUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
                <el-form-item label="词书描述" prop="name">
                  <el-input v-model="editForm.params.description" placeholder="请输入词书描述"></el-input>
                </el-form-item>
                <el-form-item label="单词数量" prop="name">
                  <el-input v-model="editForm.params.wordCount" placeholder="请输入单词数量"></el-input>
                </el-form-item>
                <el-form-item label="单词类型" prop="name">
                  <el-row v-for="(ext, index) in types" :key="index" style="margin-bottom: 4px;">
                    <el-col :span="3">
                      <el-input v-model="ext.id" :readonly="true"></el-input>
                    </el-col>
                    <el-col :span="6">
                      <el-input v-model="ext.name" :readonly="true"></el-input>
                    </el-col>
                    <el-col :span="6">
                      <el-input v-model="editForm.params.typeMap[ext.id]" placeholder="重命名类型"></el-input>
                    </el-col>
                  </el-row>
                </el-form-item>

                <el-form-item label="是否显示" prop="name">
                  <el-radio-group v-model="editForm.params.status">
                    <el-radio :label="0">不显示</el-radio>
                    <el-radio :label="1">显示</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="排序" prop="name">
                  <el-input v-model="editForm.params.sort" placeholder="排序权重"></el-input>
                </el-form-item>
              </div>
            </el-col>

          </el-form>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="handleClose">取消</el-button>
          <el-button size="small" type="goon" :loading="loading" class="title" @click="submitForm('editForm')">
            保存</el-button>
        </div>
        <div style="height: 60px; margin-top: 50px"></div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import Pagination from "../../components/Pagination";
import debounce from "../../utils/debounce";
import { bookslist, booksdelete, bookstypes, categorylist, bookscreate, booksupdate, booksupdateCount, booksqrcode, imagesrc, getUploadHeader } from "../../api/userMG";

export default {
  data() {
    return {
      title: "编辑信息",
      options: [],
      editFormVisible: false,
      //分页
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      imagesrc: "", //图片
      uploadHeader: {},
      tableData: [], //表格数据 
      types: [],
      formInline: {
        data: {},
        params: {
          pageNum: 1,
          pageSize: 10,
          category: "",
          keyword: ""
        },
      },
      dialogImageUrl: '',
      dialogVisible: false,
      //添加，修改数据
      editForm: {
        data: {},
        params: {
          "id": 0,
          "name": "",
          "description": "",
          "category": "",
          "wordCount": "",
          "coverUrl": "",
          "status": 1,
          "typeMap": {},
          "sort": 100
        },
      },
      //规则验证
      rules: {},
    };
  },
  components: {
    Pagination
  },
  created() {
    this.imagesrc = imagesrc;//上传地址
    this.uploadHeader = getUploadHeader()
    this.gettypes()
    //数据列表
    this.getlist(this.formInline);
    this.getfenlei();
  },
  methods: {
    headStyle() {
      return {
        background: "#A1BBFF",
        color: "#fff",
        letterSpacing: "2px",
        border: " 1px solid #A1BBFF",
        textAlign: "center",
        height: "39px",
      };
    },
    gettypes() {
      bookstypes({}).then((res) => {
        this.types = res.data.splice(1, res.data.length - 1)
      }).catch(() => {
      })
    },
    getfenlei() {
      let data = {
        params: {
          pageSize: 100
        },
      }
      categorylist(data)
        .then((res) => {
          this.options = res.data.records
        })
        .catch((err) => {
        });
    },
    //显示数据
    getlist(parameter) {
      this.loading = true;
      bookslist(parameter)
        .then((res) => {
          this.loading = false;
          // console.log("userlist", res);
          if (res.code != 200) {
            this.$message({
              type: "info",
              message: res.message,
            });
          } else {
            this.tableData = res.data.records;
            // 分页赋值
            this.pageparm.currentPage = this.formInline.params.pageNum;
            this.pageparm.pageSize = this.formInline.params.pageSize;
            this.pageparm.total = res.data.total;
            // console.log(this.tableData)
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("加载失败，请稍后再试！");
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.params.pageNum = parm.currentPage;
      this.formInline.params.pageSize = parm.pageSize;
      this.getlist(this.formInline);
    },
    // 搜索事件
    search() {
      this.formInline.params.pageNum = 1;
      this.getlist(this.formInline); //显示
    },
    //关闭弹框
    handleClose(done) {
      this.$confirm("还有未保存的工作哦确定关闭吗？")
        .then((_) => {
          this.editFormVisible = false
          // done();
        })
        .catch((_) => { });
    },
    //上传头像
    licenseSuccess(response, file) {
      this.editForm.params.coverUrl = response.data[0].url
    },
    //限制上传的文件
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      if (!isJPG && !isPNG) {
        this.$message.error('上传图片只能是 JPG 格式或者png格式!');
      }
      return isJPG || isPNG;
    },
    refreshCount(bookId) {
      console.log(bookId)
      const data = {
        params: {
          id: bookId,
          withUnit: 1
        },
      }
      booksupdateCount(data)
        .then((res) => {
          this.getlist(this.formInline);
          this.$message({
            message: "刷新成功！",
            type: "success",
          });
        })
        .catch((err) => {
        });
    },
    showQrcode(row) {
      this.dialogImageUrl = row.qrcodeUrl
      if (!row.qrcodeUrl) {
        booksqrcode({
          params: { id: row.id }
        }).then((res) => {
          if (res.code == 200) {
            row.qrcodeUrl = res.data
            this.dialogImageUrl = res.data
          } else {
            this.dialogVisible = false
            this.$message({
              message: res.message || "二维码获取失败！",
              type: "error",
            });
          }
        }).catch(() => {
          this.dialogVisible = false
        })
      }
      this.dialogVisible = true
    },
    delExtend(index) {
      delete this.editForm.params.typeMap[index]
      Vue.set(this.editForm, params, this.editForm.params.typeMap)
    },
    //添加，修改
    handleEdit(index, row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {//修改

        this.editForm = {

          data: {},
          params: {
            "id": row.id,
            "name": row.name,
            "description": row.description,
            "category": row.category,
            "wordCount": row.wordCount,
            "coverUrl": row.coverUrl,
            "status": row.status,
            "typeMap": row.typeMap ? JSON.parse(row.typeMap) : {},
            "sort": row.sort
          },
        }

      } else {//添加   
        this.editForm = {
          data: {},
          params: {
            "id": 0,
            "name": "",
            "description": "",
            "category": "",
            "wordCount": "",
            "coverUrl": "",
            "status": 1,
            "typeMap": {},
            "sort": 100
          },
        }

      }
    },
    //提交添加，修改
    submitForm(info) {

      debounce(() => {
        var data = JSON.parse(JSON.stringify(this.editForm))
        var typeMap = data.params.typeMap
        for (var k in typeMap) {
          if (!typeMap[k]) {
            delete typeMap[k]
          }
        }
        data.params.typeMap = typeMap
        if (data.params.id == 0) {
          bookscreate(data)
            .then(res => {
              if (res.code == 200) {
                this.editFormVisible = false;
                this.getlist(this.formInline);
                this.$message({
                  message: "保存成功！",
                  type: "success",
                });
              } else {
                this.$message({
                  type: "info",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.$message.error("保存失败，请稍后再试！");
            });

        } else {
          booksupdate(data)
            .then(res => {
              if (res.code == 200) {
                this.editFormVisible = false;
                this.getlist(this.formInline);
                this.$message({
                  message: "保存成功！",
                  type: "success",
                });
              } else {
                this.$message({
                  type: "info",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.$message.error("保存失败，请稍后再试！");
            });

        }


      }, 1500);
    },
    handleEditdel(id) {
      let data = {
        "data": {},
        "params": { "id": id },
      }
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          booksdelete(data) //删除
            .then((res) => {
              console.log("d", res);
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.getlist(this.formInline);
              } else {
                this.$message({
                  type: "info",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    peizhi(row) {
      this.$router.push({ path: './words?id=' + row.id })
    },
    showunits(row) {
      this.$router.push({ path: './units?id=' + row.id })
    },
    jihua(row) {
      this.$router.push({ path: './daily?id=' + row.id })
    },

  },
};
</script>
<style>
@import "../../assets/css/index.css";

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.divBox {
  /*flex-direction: row;*/
  float: left;
  position: relative;
  margin-right: 10px;
}

.imgSty {
  margin-left: 3px;
}

.delIcon {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 20px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 145px;
  height: 145px;
  line-height: 145px;
  text-align: center;
}

.avatar {
  width: 145px;
  height: 145px;
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/views/book/list.vue